import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20Card', {
    attrs: {
      "buttons": _vm.buttons
    },
    on: {
      "close": _vm.close,
      "saveRole": _vm.saveRole
    }
  }, [_c(VCardTitle, {
    staticClass: "pt-4 pb-0"
  }, [_c(VRow, {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "py-0 my-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('h3', {
    class: `my-0 headline ${_vm.color}--text`
  }, [_vm._v("\n          " + _vm._s(_vm.item.id ? _vm.$i18n_t('Common.edit') : _vm.$i18n_t('Common.addNew')) + "\n        ")])])], 1)], 1), _c(VCardText, {
    staticClass: "mt-0"
  }, [_c(VRow, {
    staticClass: "pa-0"
  }, [_c(VCol, {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "role_name",
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.tenant.roleName'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "disabled": _vm.isFederatedAuthRole(_vm.item.name)
    },
    model: {
      value: _vm.item.name,
      callback: function ($$v) {
        _vm.$set(_vm.item, "name", $$v);
      },
      expression: "item.name"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "role_description",
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.tenant.roleDescription'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto"
    },
    model: {
      value: _vm.item.description,
      callback: function ($$v) {
        _vm.$set(_vm.item, "description", $$v);
      },
      expression: "item.description"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('core-icons', {
    attrs: {
      "faStyle": "solid",
      "dense": ""
    },
    model: {
      value: _vm.item.properties.icon,
      callback: function ($$v) {
        _vm.$set(_vm.item.properties, "icon", $$v);
      },
      expression: "item.properties.icon"
    }
  })], 1)], 1), _c(VRow, {
    staticClass: "pt-0"
  }, [_c(VCol, {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.ruleList,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('accMgmt.tenant.rules'),
      "search-input": _vm.tagSearch,
      "multiple": "",
      "chips": "",
      "return-object": "",
      "autocomplete": "off",
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.tagSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.tagSearch = $event;
      },
      "change": function ($event) {
        _vm.tagSearch = '';
      }
    },
    model: {
      value: _vm.item.Rules,
      callback: function ($$v) {
        _vm.$set(_vm.item, "Rules", $$v);
      },
      expression: "item.Rules"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };